import './confirmation-modal.html'

/** @ngInject */
export class ConfirmationModalController {
    constructor($mdDialog, confirmationModalBean) {
        this.modalInstance = $mdDialog;
        this.modalBean = confirmationModalBean;
    }

    confirm() {
        return this.modalInstance.hide();
    }

    closeDialog() {
        return this.modalInstance.cancel();
    }
}
